import axios from "axios";
let uri = process.env.REACT_APP_SERVER_URL;

// if (process.env.REACT_APP_ENVIRONMENT == "development") {
//   uri = "http://localhost:5004/"; // local
// } else if (process.env.REACT_APP_ENVIRONMENT == "staging") {
//   uri = "https://one-capacity-staging-ba4aed8538af.herokuapp.com/"; // staging
// } else if (process.env.REACT_APP_ENVIRONMENT == "production") {
//   uri = "https://one-capacity-server-a4dd4c2b60c1.herokuapp.com/"; // production
// }

const Axios = axios.create({ baseURL: uri + "v1" });

Axios.interceptors.request.use((config) => {
  const token = window.localStorage.getItem("token");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }

  // You can modify the request config here if needed
  return config;
});

Axios.interceptors.response.use(
  (response) => {
    if (response.status == "expired") {
      navigate("/auth/login");
    }
    return response;
  },
  (error) => {
    console.error("Axios error:", error);
    return Promise.reject(error);
  },
);

export const BaseURL = uri;
export default Axios;
